import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-size",
  "use": "icon-size-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-size\"><path d=\"M0 54.857h54.796v18.286H36.531V128H18.265V73.143H0V54.857zm127.857-36.571H91.935V128H72.456V18.286H36.534V0h91.326l-.003 18.286z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/size.svg
// module id = Cr4N
// module chunks = 244